"use client";
import { defineClientConfig } from "fumadocs-openapi/ui/client";

export default defineClientConfig({
	// fumadocs-openapi's own config key for its API try-it panel — not our
	// product name, so it stays as the library spells it.
	playground: {
		transformAuthInputs: (inputs) => inputs,
	},
});
